import Viewer from './IndicatorFieldsViewer';
import IndicatorFieldsEditor from './IndicatorFieldsEditor';

export const IndicatorFieldsViewer = Viewer;
export default IndicatorFieldsEditor;
